import {openRulebook} from '../../../../shared/chat/ChatVars'
import {GameColor} from '../GameColor'
import {Sound} from '../Sound'
import {showRulebookPopup} from '../ui_rulebook/UIRulebookPopupGlobal'
import {createDivIn, createExternalImgIn, createImgIn, createSpanIn} from '../ui_utils/DomUtils'
import {UIChatPostText} from './UIChatPostText'
import {UIUtilsChat} from './UIUtilsChat'
import {ChatData} from '@colonist/shared-types'
import {cardDescriptionPrefix} from '@colonist/game-card-types'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables'
import {uiGameManager} from '../EntryShared'
import {CardEnum} from '@colonist/game-states'
import {UIPlayerOptionsPopup} from '../ui_player_options_popup/UIPlayerOptionsPopup'
import {PIXI} from '@colonist/pixi'

export class UIChatPostController {
    private readonly chatData: ChatData
    private readonly container: HTMLDivElement

    readonly post: HTMLDivElement

    private readonly textColorInGame: GameColor.Color = GameColor.Color.Gray0
    private readonly textColorInRoom: GameColor.Color = GameColor.Color.OffWhite

    private readonly isMessageSentInGame: boolean

    private readonly iconSize: number = 20

    constructor(container: HTMLDivElement, chatData: ChatData, linkEvent: (type: CardEnum) => undefined = () => undefined) {
        this.container = container
        this.chatData = chatData
        this.isMessageSentInGame = container.className.includes('game_chat')

        this.post = this.createPostDiv()

        if(this.chatData.isVictoryText == true) this.createTrophyIconInPost()

        if(chatData.profilePictureUrl) {
            const img = createExternalImgIn(this.post, chatData.profilePictureUrl, {key: 'strings:colonistCommon.utils.emptyString'})
            img.style.borderRadius = '50%'
            img.width = this.iconSize
            img.height = this.iconSize
        } else if(chatData.icon != undefined) {
            const img = createImgIn(this.post, chatData.icon)
            img.width = this.iconSize
            img.height = this.iconSize
        }

        const isLog = this.container.id == 'game-log-text'
        new UIChatPostText(this.post, this.chatData, this.textColorInGame, isLog)

        if(this.chatData.isVictoryText == true) this.createTrophyIconInPost()

        this.setEventHandlersForHelpLinks(linkEvent)
        this.setEventHandlerForOptionsPopup()
    }

    private createPostDiv(): HTMLDivElement {
        const post = createDivIn(this.container, 'message-post', '')
        if(!(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI)) post.style.color = this.isMessageSentInGame ? GameColor.getColor(this.textColorInGame) : GameColor.getColor(this.textColorInRoom)
        post.onclick = () => Sound.playSound(Sound.SoundType.Click)

        if(this.chatData.isVictoryText != true) return post
        post.classList.add('victory-text')
        post.style.color = UIUtilsChat.getTextColor('' + this.chatData.username, GameColor.getColor(this.textColorInGame))
        return post
    }

    private createTrophyIconInPost() {
        const trophyIcon = UIUtilsChat.replaceKeywordsWithImages('trophy')
        createSpanIn(this.post, '', {key: 'strings:colonistCommon.utils.#buffer', options: {value: trophyIcon, interpolation: {escapeValue: false}}})
    }

    private setEventHandlersForHelpLinks(linkEvent: (type: CardEnum) => undefined) {
        const urlPrefix = cardDescriptionPrefix
        const linkElements = this.post.getElementsByTagName('a')

        for(const link of linkElements) {
            const url = new URL(link.href)

            if(url.hash == openRulebook) {
                link.addEventListener('click', (mouseEvent: MouseEvent) => {
                    mouseEvent.preventDefault()
                    mouseEvent.stopPropagation()
                    uiGameManager.pauseController.pauseIfSinglePlayer()
                    showRulebookPopup()
                })
                continue
            }

            if(!url.hash.startsWith(urlPrefix)) return

            link.addEventListener('click', (mouseEvent: MouseEvent) => {
                mouseEvent.preventDefault()
                mouseEvent.stopPropagation()
                const base = 10
                const cardIdString = url.hash.substring(urlPrefix.length)
                const cardId = Number.parseInt(cardIdString, base)
                linkEvent(cardId as CardEnum)
            })
        }
    }

    private setEventHandlerForOptionsPopup() {
        if(!this.chatData.isSenderUser) return

        this.post.addEventListener('click', () => {
            const playerColor = this.chatData.username ? UIUtilsChat.getPlayerColorFromText(this.chatData.username) : undefined
            if(playerColor === undefined) return

            const playerValidator = uiGameManager.gameState.players.find((p) => p.color === playerColor)
            if(playerValidator === undefined) return

            const canvas = uiGameManager.canvasController
            const postPositionOnCanvasY = this.post.getBoundingClientRect().y - canvas.responsiveController.getCanvasY()
            const postPositionOnCanvasX = this.post.getBoundingClientRect().x - canvas.responsiveController.getCanvasX()
            const offsetY = this.post.getBoundingClientRect().height
            const popupX = postPositionOnCanvasX / canvas.appW
            const popupY = (postPositionOnCanvasY + offsetY) / canvas.appH
            const popupPosition = new PIXI.Point(popupX, popupY)
            const playerOptionsPopup = new UIPlayerOptionsPopup(uiGameManager, popupPosition, playerValidator)

            playerOptionsPopup.buildInGamePlayerOptionsPopup()
        })
    }
}
